import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './store'
import './directives/permission'
import './directives/contextmenu'
// 任务1(0904)：出入库列表照片列公共样式（photo-cell/photo-thumb/...——六页共用）
import './assets/photo-column.css'
import DataActionBar from '@/components/DataActionBar/index.vue'

Vue.config.productionTip = false
Vue.use(ElementUI)

// 任务6：全局 ERP 连接只读判断——基础数据页增删改按钮统一 v-if="isErpDisconnected"
// （store.erpType：NONE=未连接本地维护可增删改；≠NONE=ERP 同步数据页面只读）
Vue.mixin({
  computed: {
    isErpDisconnected() {
      return (this.$store.state.erpType || 'NONE') === 'NONE'
    }
  }
})
Vue.component('DataActionBar', DataActionBar)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
